import { GlAlert } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    name: 'ErrorsAlert',
    components: {
        GlAlert
    },
    directives: {
        SafeHtml
    },
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        errors: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        scrollOnError: {
            type: Boolean,
            required: false,
            default: true
        },
        alertClass: {
            type: String,
            required: false,
            default: 'gl-mb-5'
        }
    },
    emits: [
        'dismiss'
    ],
    computed: {
        hasErrors () {
            return this.errors.length > 0;
        }
    },
    watch: {
        errors () {
            // Watch for changes in errors and scroll into focus when errors are present
            if (this.scrollOnError && this.hasErrors) {
                this.scrollToAlert();
            }
        }
    },
    methods: {
        scrollToAlert () {
            this.$nextTick(()=>{
                this.$refs.alertRef?.$el?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        }
    }
};
